
const digest = '0de78b2c0e6d5ff45bf0e6a9ebf0088bc692fcc94eeaa04c787542496c2841d0';
const classes = {"item":"_item_470xh_1","image":"_image_470xh_13","name":"_name_470xh_20","birthNumber":"_birthNumber_470xh_26","badgeWrapper":"_badgeWrapper_470xh_30","verificationWrapper":"_verificationWrapper_470xh_35"};
const css = `._item_470xh_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #aeb8cb;
  padding: 24px;
  align-items: center;
  cursor: pointer;
  position: relative;
  background-color: #ffffff;
  border-radius: 10px;
}
._item_470xh_1 ._image_470xh_13 img {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  margin-bottom: 15px;
  object-fit: cover;
}
._item_470xh_1 ._name_470xh_20 {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  word-break: break-word;
}
._item_470xh_1 ._birthNumber_470xh_26 {
  font-size: 14px;
  color: #787c88;
}
._item_470xh_1 ._badgeWrapper_470xh_30 {
  position: absolute;
  top: 0;
  left: 0;
}
._item_470xh_1 ._verificationWrapper_470xh_35 {
  position: absolute;
  right: 10px;
  top: 7px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  